module.exports = __webpack_public_path__ + "img/school2.987853dc.jpg";